export const Types = {
  STORE_TOTAL_ITEMS_COUNT: 'summary/store_total_items_count'
}

export class StoreTotalItemsCount implements FluxStandardAction {
  type = Types.STORE_TOTAL_ITEMS_COUNT
  constructor(public payload: number) {}
}
